export const adaptAssignableUsersResponse = (response) => {
  return (
    response?.assignableUsers?.map((each) => ({
      label: each.displayName,
      value: each.accountId,
      iconUrl: each.avatarUrls['48x48'],
    })) || []
  );
};
